// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type MaterialKosten, MaterialKostenZeitraum } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateMaterialZeitraum(): (
  materialId: string,
  requestBody: MaterialKostenZeitraum
) => Promise<MaterialKosten> {
  const getAPI = useGetApi();
  return useCallback(
    async (materialId, requestBody) =>
      (await getAPI()).material.updateMaterialZeitraum({
        materialId,
        requestBody,
      }),
    [getAPI]
  );
}
